// Dinheiro do comercial — catálogo, orçamento, meta.
//
// Não é a moeda da plataforma (`useMoedaAtiva`): aquela é em que NÓS cobramos
// a assinatura do SaaS; esta é em que o cliente do nosso cliente é cobrado.
// A operação vende em real, então BRL fixo aqui é o certo — trocar por uma
// configuração antes de existir uma segunda moeda seria botão que ninguém usa.

export const formatarBRL = (valor) =>
  Number(valor || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

// "1.234,56" ou "1234.56" → 1234.56. O que o usuário digita passa por aqui
// antes de virar número; `Number("1.234,56")` sozinho devolve NaN.
export const lerValor = (texto) => {
  if (texto === null || texto === undefined || texto === "") return null;

  const bruto = String(texto).trim();
  const numero = Number(
    bruto.includes(",") ? bruto.replace(/\./g, "").replace(",", ".") : bruto,
  );

  return Number.isFinite(numero) ? numero : null;
};

// A regra do "De > Por", do lado da tela.
//
// O preço antigo (`comparePrice`) só é promoção quando é MAIOR que o preço
// atual: igual ou menor mostraria "De R$ 50,00 por R$ 50,00", que faz a loja
// parecer desatenta em vez de barata. É a mesma regra do backend
// (`helpers/PrecoDePromocao.ts`) — está nos dois lados porque a tela também
// julga o que o usuário acabou de digitar, antes de existir resposta do
// servidor.
//
// Aceita o que vem da API (número já normalizado) e o que vem do formulário
// ("1.234,56"), porque `lerValor` cuida dos dois.
export const precoDePromocao = (produto) => {
  const atual = lerValor(produto?.price);
  const antes = lerValor(produto?.comparePrice);

  if (atual === null || antes === null) return null;
  if (antes <= atual) return null;

  return antes;
};

export const promocaoValida = (produto) => precoDePromocao(produto) !== null;
